import React from 'react';
import { LEAGUE_COMING_SOON } from '../constants/league';
import TheLeagueFull from './TheLeagueFull';
import TheLeagueWaitlist from './TheLeagueWaitlist';

const TheLeague = () =>
  LEAGUE_COMING_SOON ? <TheLeagueWaitlist /> : <TheLeagueFull />;

export default TheLeague;
